import Regex from './Regex'

export default class PhoneNumber extends Regex {
  get ruleName () {
    return 'phoneNumber'
  }

  passes () {
    return super.passes(/^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/)
  }
}
